import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CompanyService } from '../../services/company.service';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, NgxSpinnerModule, CommonModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit, AfterViewInit {

  email: string = '';
  loginForm!: FormGroup;
  error?: string | null;
  successMessage?: string | null;
  @ViewChild('emailInput') emailInput!: ElementRef;

   constructor(    
    private companyService: CompanyService,
    private router: Router,
    private ngx: NgxSpinnerService, 
    private fb: FormBuilder,   
    private route: ActivatedRoute,
     
  ) { }

  ngOnInit(): void {
    sessionStorage.removeItem('isLoggingOut');
    this.buildForm();
  }

  ngAfterViewInit(): void {
    this.emailInput.nativeElement.focus();
  }
   
   buildForm(): void {
    this.loginForm = this.fb.group({
   userEmail: ['', [Validators.required, Validators.email]]
    });
   }

  backClick(): void {
    this.router.navigate(['']); 
  }  

  nextClick(): void {
    this.loginForm.markAllAsTouched();

  // Stop if invalid

  if (this.loginForm.invalid) {

    return;

  }
    else
    {
     this.sendEmailOtp();
    }
  }

  sendEmailOtp(): void {
    this.error = null;
    this.successMessage = null;

    this.ngx.show();

    this.companyService
      .sendEmailOtp(this.loginForm.get('userEmail')?.value)
      .subscribe({
        next: (response: any) => {
          this.ngx.hide();

          this.successMessage = 'OTP sent successfully.';

          sessionStorage.setItem(
            'username',
            this.loginForm.get('userEmail')?.value
          );

           const returnUrl =
    this.route.snapshot.queryParamMap.get('returnUrl');
    
if(returnUrl)
    this.router.navigate(
      ['/verify-otp'],
      {
        queryParams: {
          returnUrl: returnUrl
        }
      }
    );
      else     
      this.router.navigate(['/verify-otp']);
        },
        error: (err: HttpErrorResponse) => {
          this.ngx.hide();

          console.error(err);

          if (err.status === 0) {
            this.error = 'Unable to connect to server. Please try again later.';
          }
          else if (typeof err.error === 'string') {

            if (err.error.includes('SqlException')) {
              this.error =
                'Database connection is currently unavailable. Please try again later.';
            }
            else {
              this.error = err.error;
            }

          }
          else if (err.error?.message) {
            this.error = err.error.message;
          }
          else {
            this.error = 'An unexpected error occurred.';
          }
        }
      });
  }

  resetError(): void {
  this.error = null;
  this.successMessage = null;
}

}
